import { useState, useEffect } from "react";
import { Outlet, useLocation, useParams, matchPath } from "react-router";
import C from "classnames";

// Toolkit imports
import { LearnAppRoutes } from "sj-ui-toolkit/src/constants/routes";
import { Header } from "sj-ui-toolkit/src/atlas/components";
import { UserContextProvider } from "sj-ui-toolkit/src/atlas/contexts/User/UserContextProvider";
import { useLearnContext } from "../../context/LearnContext";
import { LevelContextProvider, NavContextProvider } from "sj-ui-toolkit/src/atlas/contexts";
import { themeClasses as T } from "sj-ui-toolkit/src/atlas/utils";

import "sj-ui-toolkit/src/atlas/styles/pathBackgrounds.scss";
import S from "./Layout.module.scss";

const defaultPathConfig = { variant: "mauve", map: "1" };

const Layout = () => {
  const location = useLocation();
  const { pathId } = useParams();
  const { isScorm } = useLearnContext();
  const [pathConfig, setPathConfig] = useState({});

  // This is here so we can accurately set pathConfig for path backgrounds in /path/:pathId
  useEffect(() => {
    const fetchPathConfig = async () => {
      try {
        // TODO: replace with live endpoint SHRPA-2585
        const response = await fetch("/futureEndpoints/pathMaps.json");
        if (!response.ok) {
          throw new Error(`Failed to fetch path config: ${response.status}`);
        }
        const data = await response.json();
        setPathConfig(data);
      } catch (error) {
        console.error("Error fetching path configuration:", error);
      }
    };

    fetchPathConfig();
  }, []);

  // Map routes to background classes
  const routeBgClassMap = {
    [LearnAppRoutes.route]: "atlas-bg-home",
    [LearnAppRoutes.routes.catalog.route]: "atlas-bg-home",
    [LearnAppRoutes.routes.lesson.route]: "atlas-bg-lesson",
    [LearnAppRoutes.routes.exercise.route]: "atlas-bg-lesson",
    [LearnAppRoutes.routes.scorm.route]: "atlas-bg-lesson",
    [LearnAppRoutes.routes.tournaments.routes.content.route]: "atlas-bg-lesson",
    [LearnAppRoutes.routes.tournaments.routes.details.route]: "path-bg-1-mauve",
    [LearnAppRoutes.routes.testConnection.route]: "atlas-bg-home",
  };

  // Loop over routeBGClassMap to find a matching route
  // Path is different due to the fact that we have 32 background variants for that page
  let bgClass = "atlas-bg-home";
  for (const route in routeBgClassMap) {
    if (matchPath(route, location.pathname)) {
      bgClass = routeBgClassMap[route];
      break;
    } else if (matchPath(LearnAppRoutes.routes.path.route, location.pathname)) {
      const individualPathConfig = (pathId && pathConfig[pathId]) || defaultPathConfig;
      const { variant, map } = individualPathConfig;

      bgClass = `path-bg-${map}-${variant}`;
    }
  }

  // Determine which content container to use
  const contentContainerClass =
    bgClass === "atlas-bg-lesson" ? T.lessonContentContainer : T.mainContentContainer;

  return (
    // @ts-expect-error - CSS custom properties are not in CSSProperties type
    <div className={C(bgClass, T.flexLayout)}>
      <UserContextProvider>
        <NavContextProvider>
          <LevelContextProvider>
            {!isScorm && <Header />}
            <main className={C({ [S.addTopPadding]: isScorm }, T.flexMain)}>
              <div className={contentContainerClass}>
                <Outlet />
              </div>
            </main>
          </LevelContextProvider>
        </NavContextProvider>
      </UserContextProvider>
    </div>
  );
};

export default Layout;
